module.exports = __webpack_public_path__ + "img/CP_Sprite.8bff0953.png";